// src/components/Blocks/DynamicBlock/DynamicBlock.tsx
import React, { Fragment } from "react";
import { useBlockDataMapping } from "../../../hooks/useBlockDataMapping";
import S from "./DynamicBlock.module.scss";
import Hero from "../../Templates/Hero/Hero.component";
import Cards from "../../Templates/Cards/Cards.component";
import TextImage from "../../Templates/TextImage/TextImage.component";
import FooterAddress from "../../Templates/Footer/FooterAddress/FooterAddress.component";
import FooterLink from "../../Templates/Footer/FooterLink/FooterLink.component";
import CustomText from "../../Templates/CustomText/CustomText.component";
import SoMe from "../../Templates/SoMe/SoMe.component";
import CraneSerialSearch from "../../Templates/CraneSerialSearch/CraneSerialSearch.component";

interface DynamicBlockProps {
    content: {
        contentType: string;
        properties: any;
    };
    settings?: {
        contentType: string;
        id: string;
        properties: {
            numberOfColumns?: number;
        };
    };
}

const BLOCK_TYPES: { [key: string]: React.ComponentType<any> } = {
    blockHero: Hero,
    cards: Cards,
    textImage: TextImage,
    footerAddress: FooterAddress,
    footerLink: FooterLink,
    textArea: CustomText,
    soMe: SoMe,
    craneSerialSearch: CraneSerialSearch,
};

export const DynamicBlock: React.FC<DynamicBlockProps> = ({ content, settings }) => {
    const { contentType } = content;
    const BlockComponent = BLOCK_TYPES[contentType];

    const mappedData = useBlockDataMapping(contentType, content, settings);

    return (
        <Fragment>
            {BlockComponent ? (
                <div className={S.content}>
                    <BlockComponent {...mappedData} />
                </div>
            ) : null}
        </Fragment>
    );
};
